import { z } from "zod";

export const stepConfigurationSchema = z.record(z.string(), z.union([z.boolean(), z.string()]));
export type StepConfiguration = z.infer<typeof stepConfigurationSchema>;

export const filterStepSchema = z.object({
	name: z.string(),
	configuration: stepConfigurationSchema.nullable().optional(),
});
export type FilterStep = z.infer<typeof filterStepSchema>;

export const productionGroupDataSchema = z.object({
	id: z.string(),
	alias: z.string(),
	configuredMachineGroups: z.array(z.string()),
	filterSteps: z.array(filterStepSchema).optional(),
});
export type ProductionGroupData = z.infer<typeof productionGroupDataSchema>;
